import { LoopModeEnum } from '@campus/ui';

export enum GuideStoryComponentEnum {
  SCORE = 'score',
  CIRCULAR_SCORE = 'circular-score',
  ABILITY_METER = 'ability-meter',
}

export interface GuideStoryInterface {
  headline: string;
  subHeadline: string;
  description?: string;
  kabasDescription?: string;
  polpoDescription?: string;
  component?: GuideStoryComponentEnum;
  kabasComponent?: GuideStoryComponentEnum;
  polpoComponent?: GuideStoryComponentEnum;
  fixedComponentValue?: number;
  hasAnimation: boolean;
  isIndeterminate?: boolean;
}

export const story: Record<number, GuideStoryInterface> = {
  1: {
    headline: `Hoe interpreteer je resultaten als leerkracht?`,
    subHeadline: `Bekwaamheid op een doel`,
    description: `Dit geeft een <strong>schatting van de bekwaamheid</strong> van een leerling <br /> om een oefening gericht <strong>op dit doel</strong> met succes uit te voeren.`,
    component: GuideStoryComponentEnum.CIRCULAR_SCORE,
    hasAnimation: true,
  },
  2: {
    headline: `Hoe interpreteer je resultaten als leerkracht?`,
    subHeadline: `Bekwaamheid op een doel`,
    description: `Dit geeft aan dat er voorlopig <strong>te weinig gegevens</strong> zijn <br /> om de <strong>bekwaamheid op dit doel</strong> van een leerling in te schatten.`,
    component: GuideStoryComponentEnum.CIRCULAR_SCORE,
    hasAnimation: false,
    isIndeterminate: true,
  },
  3: {
    headline: `Hoe interpreteer je resultaten als leerkracht?`,
    subHeadline: `Score op een oefening`,
    description: `Dit geeft aan <strong>hoeveel</strong> een leerling heeft <strong>gescoord</strong> op een oefening.<br /> <span class="flex items-center gap-3xs">Je kan de score bekijken via het leerpad met deze knop <dcr-icon icon="shared:learning-path"></dcr-icon></span>`,
    component: GuideStoryComponentEnum.SCORE,
    hasAnimation: true,
  },
  4: {
    headline: `Wat ziet een leerling per doel?`,
    subHeadline: `Voortgang op het doel`,
    kabasDescription: `<div class="[ stack stack-space-3xs center-items ]"><div>De ksnap-o-meter werkt met 2 bogen.</div><div>De eerste boog geeft aan als het doel voldoende is beheerst.</div><div>De tweede boog motiveert om een nog hoger niveau te halen.</div></div>`,
    polpoDescription: `Dit geeft een <strong>schatting van de bekwaamheid</strong> op het doel.`,
    kabasComponent: GuideStoryComponentEnum.ABILITY_METER,
    polpoComponent: GuideStoryComponentEnum.CIRCULAR_SCORE,
    hasAnimation: true,
  },
};

// An array from 0 to 100 with increments of 10
export const teacherAnimationSteps = Array.from({ length: 11 }, (_, i) => i * 10);

// An array with an object for the value and the ability mode
const abilityMeterMasterSteps = Array.from({ length: 11 }, (_, i) => ({
  value: i * 10,
  mode: LoopModeEnum.MASTER,
}));

const abilityMeterExpertSteps = Array.from({ length: 11 }, (_, i) => ({
  value: i * 10,
  mode: LoopModeEnum.EXPERT,
}));

export const kabasStudentAnimationSteps = [...abilityMeterMasterSteps, ...abilityMeterExpertSteps];
export const polpoStudentAnimationSteps = Array.from({ length: 11 }, (_, i) => i * 10);
